import { observer } from 'mobx-react-lite'
import type { NotesRequestedSupportingItemViewModel } from '@/features/jobs/details/tax-type/info-gathering/notes/NotesRequestedSupportingItemViewModel'
import { TextAreaContainer } from '@/components/inputs/TextAreaContainer'
import { FormFieldSet } from '@/components/Form'
import { FormContainer } from '@/components/FormContainer'

export interface NotesEditorProps {
  vm: NotesRequestedSupportingItemViewModel
  formId?: string
  isDisabled?: boolean
  testId?: string
}

export const NotesEditor = observer(function NotesEditor({
  vm,
  formId,
  isDisabled,
  testId,
}: NotesEditorProps) {
  return (
    <FormContainer
      id={formId}
      onSubmit={vm.save}
      disabled={isDisabled || vm.save.pending}
      testId={testId}
    >
      <FormFieldSet>
        <TextAreaContainer
          model={vm}
          field="editedText"
          label="Notes"
          rows={8}
          placeholder="Enter any additional notes or information..."
          disabled={vm.isReadOnly}
        />
      </FormFieldSet>
    </FormContainer>
  )
})
